import React from 'react';

export function LoadingState({ message = '読み込み中...', className = '' }) {
  return (
    <div className={`flex flex-col items-center justify-center py-16 ${className}`}>
      <div
        className="w-8 h-8 border-2 border-prodia-border border-t-prodia-primary rounded-full animate-spin mb-3"
        role="status"
        aria-label={message}
      />
      <p className="text-sm text-prodia-text-secondary">{message}</p>
    </div>
  );
}

export default LoadingState;
